// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2X0BT","hidden":"Loader_hidden__3Jj_p"};